module.exports = __webpack_public_path__ + "img/logoNovaccessSmall.01df0dca.svg";